import _ from 'lodash'

export const getRegionLevel1Object = (product) => {
  if (product) {
    let regionObject = product.region_object
    if (product.region_level_0 === 'United States') {
      regionObject = {
        name: product.region_level_1,
        link: `/store/regions/${_.kebabCase(product.region_level_1)}`,
      }
    }
    return regionObject
  }
  return null
}

export const getRegionLevel2Object = (product) => {
  if (product) {
    let regionObject = product.appellation
    if (product.region_level_0 === 'United States') {
      regionObject = {
        name: product.region_level_2,
        link: `/store/regions/${_.kebabCase(product.region_level_2)}`,
      }
    }
    return regionObject
  }
  return null
}
